"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CLink = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const LINK_COLOR = '#4472c4';
const StyledLink = (0, _styles.styled)(_Link.default, {
  shouldForwardProp: prop => prop !== '$button'
})(_ref => {
  let {
    theme,
    $button
  } = _ref;
  return _objectSpread(_objectSpread({
    color: LINK_COLOR,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: theme.typography.body2.fontSize
  }, !!$button && {
    fontSize: theme.typography.body2.fontSize,
    fontFamily: theme.typography.fontFamily
  }), {}, {
    '&:hover': {
      textDecoration: 'underline'
    }
  });
});

/**
 * リンク部品
 * @prop {func} [onClick] - クリック時イベント（ボタンとして使用する場合必須）<br/>
 * シグネチャ: ():void
 * @prop {string} [href] - リンク先URL（アンカーとして使用する場合必須）
 * @prop {string} [target] - リンク先のURLを表示する場所（アンカーとして使用する場合に任意で指定）
 * @prop {string} [rel] - 対象オブジェクトとリンクオブジェクトとの関係（アンカーとして使用する場合に任意で指定）
 */
const CLink = props => {
  const {
    onClick,
    href,
    target,
    rel,
    children,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "span"
  }, onClick ? /*#__PURE__*/_react.default.createElement(StyledLink, {
    className: className,
    onClick: onClick,
    underline: "always",
    $button: true
  }, children) : /*#__PURE__*/_react.default.createElement(StyledLink, {
    href: href,
    target: target,
    rel: rel,
    className: className,
    underline: "always"
  }, children));
};
exports.CLink = CLink;
CLink.propTypes = {
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  target: _propTypes.default.string,
  rel: _propTypes.default.string
};
var _default = exports.default = CLink;